import { render, staticRenderFns } from "./LensCreativeTestView.vue?vue&type=template&id=bc2d3cb8&scoped=true"
import script from "./LensCreativeTestView.vue?vue&type=script&lang=js"
export * from "./LensCreativeTestView.vue?vue&type=script&lang=js"
import style0 from "./LensCreativeTestView.vue?vue&type=style&index=0&id=bc2d3cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2d3cb8",
  null
  
)

export default component.exports